import React from 'react';
import { Alert } from 'components/UI/Alert/Alert';
import { Trans } from '@lingui/macro';
import { useSelector } from 'react-redux';
import { IdTicketsState } from 'model/dashboardTickets/dTicketsReducer';
import { ExclamationCircleIcon } from '@heroicons/react/solid';
import { Loader } from 'components/UI/Loader/Loader';


export const TsoInfo: React.FC = () => {

    const loader = useSelector((state: {
        dTickets: IdTicketsState
    }) => state.dTickets.merchantDataLoader)
    const merchantData = useSelector((state: {
        dTickets: IdTicketsState
    }) => state.dTickets.merchantData)

    let component = <section
        className={ 'flex flex-wrap sm:flex-nowrap justify-center flex-grow gap-2 text-sm font-medium text-gray-700 tracking-wide py-2 px-4 rounded-md bg-blue-50 mr-2' }>
        <div className={ 'flex' }>
            <span><ExclamationCircleIcon className={ `h-5 w-5 text-blue-400 mr-2` } aria-hidden="true"/></span>
            <p className={ ' text-blue-800' }><Trans>You may contact the support center using</Trans>:</p>
        </div>

        <div>
            <p className={ ' text-blue-800' }>- <Trans>tickets</Trans>
                <span className={ 'font-normal text-blue-700' }>( <Trans>Click on "Add" button to create a ticket</Trans> )</span>
            </p>
            { (!!merchantData && merchantData.support?.phoneNumber ) &&
                <p className={ ' text-blue-800' }> {!merchantData.support?.phoneNumber
                    ? <p>- <Trans>Phone - unavailable</Trans></p>
                    : <p>- <Trans>phone</Trans>: <a href={ `tel:${merchantData.support?.phoneNumber}` }>{ merchantData.support?.phoneNumber }</a></p>}
                </p> }
        </div>
    </section>


    if (!!merchantData && merchantData.support === null) {
        component = <section className={ ' mr-2' }>
            <Alert type={ 'warning' }
                   title={ <Trans>Please, contact to the administration of the service , your merchant is not
                       assigned to TSO !</Trans> }/>
        </section>
    }


    return (
        <div className={ 'relative' }>
            { component }
            { loader && <Loader/> }
        </div>
    )

}

